import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import SectionHeading from "./SectionHeading";
import { SERVICES } from "../data/site";

export default function ServicesSection() {
  return (
    <section className="bg-white py-24 md:py-32" data-testid="services-section">
      <div className="container-x">
        <SectionHeading
          eyebrow="What we build"
          title="Technology solutions designed to solve real business problems."
          subtitle="Four focused practices, one connected engineering mindset."
          max="max-w-3xl"
        />

        <div className="mt-16 grid gap-5 sm:grid-cols-2">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
                className="group"
              >
                <Link
                  to={s.to}
                  data-testid={`service-card-${i}`}
                  className="relative flex h-full flex-col overflow-hidden rounded-3xl border border-slate-200 bg-white p-8 transition-all duration-500 hover:-translate-y-1.5 hover:border-slate-300 hover:shadow-[0_30px_60px_-30px_rgba(7,17,31,0.25)]"
                >
                  <div className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full accent-bg opacity-0 blur-3xl transition-opacity duration-500 group-hover:opacity-20" />
                  <div className="flex items-start justify-between">
                    <span className="grid h-14 w-14 place-items-center rounded-2xl bg-[#07111F] text-cyan-300 transition-colors duration-500 group-hover:accent-bg group-hover:text-[#07111F]">
                      <Icon size={24} strokeWidth={1.8} />
                    </span>
                    <ArrowUpRight className="text-slate-300 transition-all duration-500 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-[#07111F]" />
                  </div>
                  <h3 className="mt-7 font-display text-xl font-medium tracking-tight text-[#07111F]">{s.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-slate-500">{s.desc}</p>
                  <span className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-[#07111F]">
                    Learn More
                    <span className="h-px w-6 bg-[#07111F] transition-all duration-500 group-hover:w-10" />
                  </span>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
